import { Zap, Plane, Briefcase, Users, BadgeDollarSign } from "lucide-react";
import { Reveal, ChapterHead } from "./Reveal";
import { trackContact } from "../lib/track";

const SERVICES = [
  {
    icon: Zap,
    title: "ASAP Local Rides",
    text: "Need a taxi ASAP? A cab near you in 3–7 minutes, anywhere in Sydney — day, night, rain or New Year's Eve.",
  },
  {
    icon: Plane,
    title: "Sydney Airport Transfers",
    text: "Fixed-price runs to Sydney Airport (T1/T2/T3, Mascot) with flight-aware pickup timing and generous luggage room.",
  },
  {
    icon: Briefcase,
    title: "Corporate Chauffeur",
    text: "Executive sedans for CBD meetings and events, with emailed receipts and account billing for your business.",
  },
  {
    icon: Users,
    title: "Group & Maxi Vans",
    text: "Maxi vans for up to 11 — airport runs, weddings, nights out. One booking, everyone in one cab.",
  },
  {
    icon: BadgeDollarSign,
    title: "Fixed Meter Pricing",
    text: "Real taxis, real meters. The price you see is the price you pay — no surge, no mystery fees, ever.",
  },
];

export const Services = () => (
  <section id="services" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <ChapterHead
        num="CHAPTER 01"
        kicker="What we do"
        title="Sydney taxi services for every kind of trip"
      />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => (
          <Reveal
            key={s.title}
            delay={i * 0.07}
            className={i === 0 ? "md:col-span-2 lg:col-span-1" : ""}
          >
            <article
              data-testid={`service-card-${i + 1}`}
              className="group h-full bg-ink-800 border border-gold-400/10 rounded-2xl p-8 transition-all duration-300 hover:border-gold-400/40 hover:-translate-y-1"
            >
              <div className="flex items-start justify-between mb-6">
                <s.icon size={26} className="text-gold-400" strokeWidth={1.6} />
                <span className="font-mono text-xs text-gold-400/60">0{i + 1}</span>
              </div>
              <h3 className="font-display text-xl font-bold text-white mb-3">{s.title}</h3>
              <p className="text-sm leading-relaxed text-[#99A1B3]">{s.text}</p>
            </article>
          </Reveal>
        ))}
        <Reveal delay={0.35} className="md:col-span-2 lg:col-span-3">
          <div className="bg-ink-800/60 border border-gold-400/10 rounded-2xl px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p className="text-sm text-[#99A1B3]">
              <span className="text-white font-semibold">Not sure which ride fits?</span>{" "}
              Our dispatcher will match you in one call.
            </p>
            <a
              href="tel:1300582485"
              onClick={trackContact}
              data-testid="services-call-link"
              className="shrink-0 rounded-full border border-gold-400/40 text-gold-300 font-semibold px-6 py-2.5 text-sm hover:bg-gold-400/10 transition-colors duration-200"
            >
              1300 582 485
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
